/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/
import { Box, IconButton, Popover, Tooltip } from "@mui/material";
import React from "react";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import "./helpPopup.scss";

export const HelpPopup = () => {
  const [helpUserMenuOpen, setHelpUserMenuOpen] =
    React.useState<null | HTMLElement>(null);

  const handleOpenHelpMenu = (event: React.MouseEvent<HTMLElement>) => {
    setHelpUserMenuOpen(event.currentTarget);
  };

  const handleCloseHelpMenu = () => {
    setHelpUserMenuOpen(null);
  };

  return (
    <Box sx={{ flexGrow: 0 }} className="profileWrapper">
      <div className="helpTextIconMain">
        <Tooltip title="Help">
          <IconButton onClick={handleOpenHelpMenu}>
            <HelpOutlineIcon className="helpTextIcon" />
          </IconButton>
        </Tooltip>
      </div>
      <Popover
        className="menulist"
        anchorEl={helpUserMenuOpen}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        open={Boolean(helpUserMenuOpen)}
        onClose={handleCloseHelpMenu}
      >
        <div className="helpPopup">
          <span className="helpPopupTitle">
            <ContactSupportIcon
              color="primary"
              className="contactSupportIcon"
            />{" "}
            Contact us
          </span>
          <span className="helpPopupText">
            For any assistance/feedback write <br />
            to us at{" "}
            <a href="mailto:support@infraclear.com" className="emailText">
              {" "}
              support@infraclear.com
            </a>
          </span>
        </div>
      </Popover>
    </Box>
  );
};
